import { createSlice } from '@reduxjs/toolkit';

import {
 serviceGetCredential,
 servicePostCredential,
 servicePutCredential,
 serviceDeleteCredential,
} from 'utils';


const initialState = {
  data: null,
  isLoaded: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  success: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
  error: {
    post: false,
    put: false,
    delete: false,
    get: false,
  },
}

const CredentialSlice = createSlice({
  name: 'credential',
  initialState,
  reducers: {
    dataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, [action.payload]: true } };
    },

    dataSuccess(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        success: { ...state.success, [action.payload.fetchType]: true },
        data: action.payload.data || null,
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        error: { ...state.error, [action.payload.fetchType]: action.payload.data?.message },
      };
    },

    cleanUpCredential() {
      return initialState;
    },

    cleanUpMessageCredential(state) {
      return {
        ...state,
        data: null,
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },

  }
});

const {
  dataRequest,
  dataSuccess,
  dataFailure,
  cleanUpCredential,
  cleanUpMessageCredential
} = CredentialSlice.actions;


const fetchGetCredential = (query) => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetCredential(query)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'get'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'get'})));
  };
};

const fetchPostCredential = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('put'));
    servicePostCredential(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'put'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'put'})));
  };
};

const fetchPutCredential = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('put'));
    servicePutCredential(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'put'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'put'})));
  };
};

const fetchDeleteCredential = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('delete'));
    serviceDeleteCredential(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'delete'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'delete'})));
  };
};

export {
  fetchGetCredential,
  fetchPostCredential,
  fetchPutCredential,
  fetchDeleteCredential,
  cleanUpCredential,
  cleanUpMessageCredential
};

export default CredentialSlice.reducer;
